import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { FragmentMessages } from "../../common/fragment-messages";

export default class KickOff extends Fragment {
    constructor(kickedTo) {
        super();

        this.code = "KO";
        this.kickedTo = kickedTo;

        this.requiredData = [
            {
                name: "kickedTo",
                type: FragmentDataType.FieldPosition,
                displayName: "Kicked To",
                title: "Kicked To",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const message = `Kickoff by ${stringifier.firstInitial(
            summaryContext.kickedBy
        )} for ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.kickedTo,
            false
        )}`;
        const titleMessage = `Kickoff from ${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            summaryContext.fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )}`;

        return new FragmentSummary(message, titleMessage);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.homeTeamHasPossession =
            !summaryContext.homeTeamHasPossession;
        summaryContext.fieldPosition = this.kickedTo;
        summaryContext.kickedOffBallSpot = this.kickedTo;
        summaryContext.sopPrinted = true;
        summaryContext.isKickOffPlay = true;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
